import { StyledEmphasisedBackground } from "@components/emphasisedBackground/EmphasisedBackground.styles";
import React from "react";

interface IProps {
    className?: string;
}

const EmphasisedBackground: React.FC<IProps> = (props) => {
    return (
        <StyledEmphasisedBackground className={props.className}>
            {props.children}
        </StyledEmphasisedBackground>
    );
};

export default EmphasisedBackground;